import { useEffect, useRef, useState } from "react";
import { Button, ImagePlus, useToast } from "@repo/ui";
import { useBrandCreationContext } from "../../contexts/brand-creation-context-provider";

const MB = 1024 * 1024;

const MAX_MB = {
  default: 10 * MB,
  bmp: 20 * MB,
};

export const BrandImageUpload = () => {
  const { showToast } = useToast();
  const { updateState } = useBrandCreationContext();
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;
    if (file.type === "image/bmp" && file.size > MAX_MB.bmp) {
      event.target.value = "";
      showToast(
        "warning",
        `BMP files must be smaller than ${MAX_MB.bmp / MB}MB.`,
        "Large image file"
      );
      return;
    }

    if (file.size > MAX_MB.default) {
      event.target.value = "";
      showToast(
        "warning",
        `Image is too large. Max size is ${MAX_MB.default / MB}MB.`,
        "Large image file"
      );
      return;
    }
    setPreviewUrl(URL.createObjectURL(file));
    updateState("imageFile", file);
  };

  useEffect(() => {
    return () => {
      if (previewUrl) {
        URL.revokeObjectURL(previewUrl);
      }
    };
  }, [previewUrl]);
  return (
    <>
      <Button
        className="flex-shrink-0"
        icon={
          previewUrl ? (
            <img
              src={previewUrl}
              alt="Brand preview"
              className="h-11 w-11 rounded-full object-cover"
            />
          ) : (
            <ImagePlus />
          )
        }
        size={"icon_lg"}
        variant="secondary"
        onClick={() => fileInputRef.current?.click()}
        type="button"
      />
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        className="hidden"
        accept="image/png, image/jpeg, image/webp, image/gif, image/svg+xml, image/avif, image/ico, image/bmp"
      />
    </>
  );
};
